/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_ButtonInputs */



/**
* | output |
* | --- |
* | "Sync Changes" |
*
* @param {Event_Group_Sync_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_button = /** @type {((inputs?: Event_Group_Sync_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sync Changes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sync Changes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sync Changes")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Sync Changes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sync Changes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Sync Changes")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Sync Changes")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Sync Changes")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sync Changes")
	return /** @type {LocalizedString} */ ("Sync Changes")
});